import * as yup from 'yup';
import {i18n2} from 'features/i18n/i18n';
import {buildPasswordSchema} from './buildPasswordSchema';

export const CollaboSchema = (onlyRead = false, settings: any) => {
  const RealCollaboSchema = () =>
    yup.object({
      name: yup
        .string()
        .required(i18n2._('Este campo es obligatorio'))
        .max(100)
        .label(i18n2._('Nombre')),
      meta4EmployeeId: yup
        .string()
        .max(9)
        .nullable(true)
        .label(i18n2._('Meta4 Employee Id')),
      cwid: yup.string().max(39).label(i18n2._('CWID')),
      password: buildPasswordSchema(settings),
      iD_Sector: yup
        .string()
        .required(i18n2._('Este campo es obligatorio'))
        .label(i18n2._('#Sector')),
      iD_Profile_Web: yup
        .string()
        .required(i18n2._('Este campo es obligatorio'))
        .label(i18n2._('#Perfil')),
      iD_Shift: yup
        .string()
        .nullable(true)
        .notRequired()
        .label(i18n2._('#Turno')),
      sector_Name: yup.string().label(i18n2._('Sector')),
      profile_Name: yup.string().label(i18n2._('Perfil')),
      shift_Name: yup.string().nullable(true).label(i18n2._('Turno')),
      role: yup.number().label(i18n2._('Role')),
      hire_Date: yup
        .date()
        .nullable()
        .transform((value, originalValue) =>
          originalValue === '' ? null : value,
        )
        .notRequired()
        .label(i18n2._('Fecha de contratación')),
      active: yup.number().label(i18n2._('Estado')),
      email: yup
        .string()
        .email(i18n2._('Ingrese un email válido'))
        .notRequired()
        .nullable()
        .label(i18n2._('Email')),
      pdfName: yup.string().label(i18n2._('nombre del archivo')),
      capa_Initial: yup
        .bool()
        .required(i18n2._('Este campo es obligatorio'))
        .nullable(true)
        .label(i18n2._('Capacitación Inicial')),
      external: yup.bool().nullable(true).label(i18n2._('Externo')),
      onboard_Date: yup.date().label(i18n2._('Alta en el sistema')),
      revision: yup.number().label(i18n2._('Revision')),
      reason: yup
        .string()
        .max(255)
        .required(i18n2._('Este campo es obligatorio'))
        .label(i18n2._('Motivo')),
      updateDate: yup.date().label(i18n2._('Fecha de actualizacion')),
      updatedBy: yup.string().label(i18n2._('Actualizado por')),
    });

  const readOnlySchema = () =>
    yup.object({
      // onTimeRate: yup
      //     .number()
      //     .label(i18n2._('OnTime (%)')),
      // presentRate: yup
      //     .number()
      //     .label(i18n2._('Asistencia') + ' (%)'),
      // passRate: yup
      //     .number()
      //     .label(i18n2._('Aprobados') + ' (%)'),
    });

  return onlyRead === false
    ? RealCollaboSchema()
    : readOnlySchema().concat(RealCollaboSchema());
};
